import React from 'react';
import { InputSearch } from 'components';
import onClickOutside from 'react-onclickoutside';
import search_icon from 'assets/imgs/search.png';

class Search extends React.PureComponent {
  state = {
    isClickOutSide: false,
    openSearch: false,
  }

  handleClickOutside = () => {
    this.props.clickOutSide();
    this.setState({ isClickOutSide: false });
  }

  setOpenSearch = () => {
    this.setState({ isClickOutSide: !this.state.isClickOutSide });
  }

  onSearch = () => {
    this.setState({ isClickOutSide: false });
    this.props.onEnter();
  }

  render() {
    const { valueSearch, setValueSearch } = this.props;
    const { isClickOutSide } = this.state;

    return (
      <div>
        <img alt="search" src={search_icon} className="header__search-icon"
          onClick={this.setOpenSearch} />

        {isClickOutSide &&
          <div className="header__search-wrapper">
            <InputSearch
              value={valueSearch}
              handleOnChange={(value) => setValueSearch(value)}
              onSearch={this.onSearch}
              autoFocus
            />
          </div>
        }
      </div>
    )
  }
}

export default onClickOutside(Search);
